<template>
  <div class="settings-tag-select">
    <div class="settings-tag-select__field d-flex align-items-center">
      <div class="settings-tag-select__display">
        {{ { tag1, tag2 } | userTag }}
      </div>
      <div class="settings-tag-select__btn-wrap">
        <button
          type="button"
          class="btn btn-secondary btn--small settings-tag-select__btn"
          @click="openMenu">
          選択
        </button>
        <div
          v-if="menuOpen"
          class="settings-tag-select__overlay"
          @click.self="onCancel" />
        <div
          v-if="menuOpen"
          class="settings-tag-select__menu">
          <div class="settings-tag-select__menu-columns">
            <div class="settings-tag-select__menu-col">
              <div class="settings-tag-select__menu-col-label">
                タグ1
              </div>
              <div
                class="settings-tag-select__menu-item settings-tag-select__menu-item--none"
                @click="selectTag('localTag1', null)">
                <span
                  class="settings-tag-select__radio"
                  :class="{ 'settings-tag-select__radio--checked': localTag1 === null }">
                  <span
                    v-if="localTag1 === null"
                    class="settings-tag-select__radio-dot" />
                </span>
                <span class="settings-tag-select__item-text">選択なし</span>
              </div>
              <div class="settings-tag-select__menu-items-grid">
                <div
                  v-for="opt in tag1SelectableOptions"
                  :key="opt.value"
                  class="settings-tag-select__menu-item"
                  @click="selectTag('localTag1', opt.value)">
                  <span
                    class="settings-tag-select__radio"
                    :class="{ 'settings-tag-select__radio--checked': localTag1 === opt.value }">
                    <span
                      v-if="localTag1 === opt.value"
                      class="settings-tag-select__radio-dot" />
                  </span>
                  <span class="settings-tag-select__item-text">{{ opt.text }}</span>
                </div>
              </div>
            </div>
            <div class="settings-tag-select__menu-col">
              <div class="settings-tag-select__menu-col-label">
                タグ2
              </div>
              <div
                class="settings-tag-select__menu-item settings-tag-select__menu-item--none"
                @click="selectTag('localTag2', null)">
                <span
                  class="settings-tag-select__radio"
                  :class="{ 'settings-tag-select__radio--checked': localTag2 === null }">
                  <span
                    v-if="localTag2 === null"
                    class="settings-tag-select__radio-dot" />
                </span>
                <span class="settings-tag-select__item-text">選択なし</span>
              </div>
              <div class="settings-tag-select__menu-items-grid">
                <div
                  v-for="opt in tag2SelectableOptions"
                  :key="opt.value"
                  class="settings-tag-select__menu-item"
                  @click="selectTag('localTag2', opt.value)">
                  <span
                    class="settings-tag-select__radio"
                    :class="{ 'settings-tag-select__radio--checked': localTag2 === opt.value }">
                    <span
                      v-if="localTag2 === opt.value"
                      class="settings-tag-select__radio-dot" />
                  </span>
                  <span class="settings-tag-select__item-text">{{ opt.text }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="settings-tag-select__menu-footer">
            <button
              type="button"
              class="settings-tag-select__footer-btn"
              @click="onCancel">
              キャンセル
            </button>
            <button
              type="button"
              class="settings-tag-select__footer-btn settings-tag-select__footer-btn--primary"
              @click="onSave">
              保存
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="general-form__notice mt-2">
      <p>※カテゴリや学年などチームのルールに合わせて自分にタグをつけます</p>
    </div>
  </div>
</template>

<script>
import { tag1SelectableOptions, tag2SelectableOptions } from '@/helper/tag'

export default {
  props: {
    tag1: {
      type: String,
      default: null,
    },
    tag2: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      menuOpen: false,
      localTag1: null,
      localTag2: null,
      tag1SelectableOptions,
      tag2SelectableOptions,
    }
  },
  methods: {
    openMenu() {
      this.localTag1 = this.tag1 ?? null
      this.localTag2 = this.tag2 != null ? String(this.tag2) : null
      this.menuOpen = true
    },
    selectTag(key, value) {
      this[key] = value
    },
    onCancel() {
      this.menuOpen = false
    },
    onSave() {
      this.$emit('save', { tag1: this.localTag1, tag2: this.localTag2 })
      this.menuOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/variable';

.settings-tag-select {
  &__field {
    gap: 8px;
  }

  &__display {
    flex: 1;
    min-height: 38px;
    padding: 6px 12px;
    background-color: $white;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: $fs-m;
    line-height: 1.5;
  }

  &__btn {
    white-space: nowrap;
  }

  &__btn-wrap {
    position: relative;
    flex-shrink: 0;
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }

  &__menu {
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    z-index: 1001;
    background: $white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    padding: 20px 24px 12px;
    min-width: 345px;
    max-width: 345px;
  }

  &__menu-columns {
    display: flex;
    gap: 24px;
  }

  &__menu-col {
    flex: 1;
  }

  &__menu-col-label {
    font-weight: bold;
    font-size: $fs-m;
    margin-bottom: 8px;
  }

  &__menu-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 3px 0;
    cursor: pointer;
    user-select: none;

    &--none {
      margin-bottom: 6px;
      padding-bottom: 6px;
      border-bottom: 1px solid $grey10;
    }
  }

  &__menu-items-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(10, auto);
    grid-auto-flow: column;
    gap: 4px;
  }

  &__radio {
    width: 18px;
    height: 18px;
    border: 2px solid $grey11;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: border-color 0.1s;

    &--checked {
      border-color: $l-blue;
    }
  }

  &__radio-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: $l-blue;
  }

  &__item-text {
    font-size: $fs-m;
  }

  &__menu-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    border-top: 1px solid $grey10;
    padding-top: 8px;
  }

  &__footer-btn {
    font-size: $fs-m;
    font-weight: bold;
    color: $l-blue;
    background: none;
    border: none;
    padding: 4px 8px;
    cursor: pointer;

    &--primary {
      color: $white;
      background-color: $l-blue;
      border-radius: 6px;
      padding: 6px 16px;
    }
  }
}
</style>
